import { useMemo, useState } from 'react';
import AdminContentCreation from './AdminContentCreation';
import AdminNewsManager from './AdminNewsManager';
import AdminSlotReviewsManager from './AdminSlotReviewsManager';
import AdminBulkRewrite from './AdminBulkRewrite';

function AdminAiConsole() {
  const tabs = useMemo(
    () => [
      { key: 'create', label: 'Content Creation' },
      { key: 'news', label: 'News' },
      { key: 'slots', label: 'Slots review' },
      { key: 'bulk', label: 'Bulk rewrite' },
    ],
    []
  );

  const [activeTab, setActiveTab] = useState('create');

  return (
    <section aria-label="Admin panel">
      <div className="content-card" style={{ marginBottom: 16 }}>
        <div className="content-card-header">
          <div>
            <div className="section-title">Admin panel</div>
            <h1 className="section-subtitle">Content management</h1>
          </div>
          <div className="tabs" aria-label="Admin tabs">
            {tabs.map((t) => (
              <button
                key={t.key}
                type="button"
                className={`tab-pill ${activeTab === t.key ? 'active' : ''}`}
                onClick={() => setActiveTab(t.key)}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>
        <p className="secondary-text">
          Manage content: edit text, update images, and delete items.
        </p>
      </div>

      {activeTab === 'create' && <AdminContentCreation />}
      {activeTab === 'news' && <AdminNewsManager />}
      {activeTab === 'slots' && <AdminSlotReviewsManager />}
      {activeTab === 'bulk' && <AdminBulkRewrite />}
    </section>
  );
}

export default AdminAiConsole;


